// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gTw5w","inline":"_1XbbAz","contentCenter":"_3qOtim","narrow":"_3Q6kdW","wide":"_2uGEzX"};